$(function() {
  if ($(".view-more-target p").text().length < 50) {
    $(".view-more").hide();
  }

  $(".view-more").click(function() {
    $(this).text(function(i, text) {
      return text === "Close" ? "Read More" : "Close";
    });
  });
});
